export default function useChartMove({
  charts,
  swapPanelNames,
  initCharts,
  setChartsHeight,
  setChartsWidth,
  replayData,
}) {
  const move = (id, moveUp) => {
    const swapId = moveUp ? id - 1 : id + 1
    if (swapId < 0 || swapId >= charts.length) return

    const currentRange = charts[0].timeScale().getVisibleLogicalRange()
    charts.forEach(chart => chart && chart.remove())

    swapPanelNames(id, swapId)

    initCharts()
    setChartsHeight()
    setChartsWidth()
    replayData()

    charts[0].timeScale().setVisibleLogicalRange(currentRange)
  }

  return { move }
}
